module.exports = __webpack_public_path__ + "static/media/bet-logo-big-cash.da6a9803.png";